import { PROFESSION_TITLES } from "./registrationWizardConstants";
export {
  getProfilePhoneError,
  getProfilePhoneForSave,
  isProfilePhoneEmpty,
} from "../profile/profileSectionValidation";

const PASSWORD_POLICY = {
  minLength: 8,
  hasUpper: /[A-Z]/,
  hasLower: /[a-z]/,
  hasDigit: /[0-9]/,
};

export const checkPasswordPolicy = (password) => ({
  minLength: password.length >= PASSWORD_POLICY.minLength,
  hasUpper: PASSWORD_POLICY.hasUpper.test(password),
  hasLower: PASSWORD_POLICY.hasLower.test(password),
  hasDigit: PASSWORD_POLICY.hasDigit.test(password),
});

export const isPasswordPolicyMet = (password) =>
  Object.values(checkPasswordPolicy(password)).every(Boolean);

export const getPasswordStrength = (password) => {
  if (!password) return null;
  const metCount = Object.values(checkPasswordPolicy(password)).filter(Boolean).length;
  if (metCount <= 1) return "weak";
  if (metCount <= 3) return "mid";
  return "strong";
};

export const trimRequired = (value) =>
  value !== undefined && value !== null && String(value).trim().length > 0;

export const isValidProfession = (value) =>
  PROFESSION_TITLES.some((item) => item.value === value);

export const isDobEmpty = (birthMonth, birthDay, birthYear) =>
  !birthMonth && !birthDay && !birthYear;

export const isDobValid = (birthMonth, birthDay, birthYear) => {
  if (!birthMonth || !birthDay || !birthYear) return false;
  const month = Number(birthMonth);
  const day = Number(birthDay);
  const year = Number(birthYear);
  if (!month || !day || !year) return false;
  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return false;
  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date <= today;
};

/** Optional DOB: empty is valid; partial or invalid calendar dates are not. */
export const isOptionalDobValid = (birthMonth, birthDay, birthYear) =>
  isDobEmpty(birthMonth, birthDay, birthYear) ||
  isDobValid(birthMonth, birthDay, birthYear);

export const formatBirthDate = (birthMonth, birthDay, birthYear) => {
  if (!isDobValid(birthMonth, birthDay, birthYear)) return null;
  const month = String(birthMonth).padStart(2, "0");
  const day = String(birthDay).padStart(2, "0");
  return `${birthYear}-${month}-${day}`;
};

export const transformProfessionsToApiFormat = (profession, experienceSince) => {
  const payload = {
    professions: [{ profession }],
  };
  if (experienceSince) {
    payload.experienceSince = Number(experienceSince);
  }
  return payload;
};
